import React, { useState, useRef } from 'react';

const VideoToShorts = () => {
  const [videoFile, setVideoFile] = useState(null);
  const [videoUrl, setVideoUrl] = useState('');
  const [clips, setClips] = useState([]);
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  const videoRef = useRef();

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setVideoFile(file);
      setVideoUrl(URL.createObjectURL(file));
    }
  };

  const generateClip = async () => {
    if (!start || !end || !videoFile) return alert('Please select start and end times.');

    const startTime = parseFloat(start);
    const endTime = parseFloat(end);
    if (isNaN(startTime) || isNaN(endTime) || startTime >= endTime) {
      alert('Invalid start or end time.');
      return;
    }

    const videoBlob = videoFile;
    const videoDuration = videoRef.current.duration;
    const clipDuration = endTime - startTime;
    const clipRatio = clipDuration / videoDuration;
    const fileSize = videoBlob.size;

    const startByte = Math.floor((startTime / videoDuration) * fileSize);
    const endByte = Math.floor((endTime / videoDuration) * fileSize);

    const slicedBlob = videoBlob.slice(startByte, endByte, 'video/mp4');
    const url = URL.createObjectURL(slicedBlob);
    setClips(prev => [...prev, { url, start, end }]);
  };

  return (
    <div className="p-4 max-w-xl mx-auto">
      <h2 className="text-2xl font-semibold mb-4">MP4 to Shorts Generator (No FFmpeg)</h2>

      <input
        type="file"
        accept="video/mp4"
        onChange={handleFileUpload}
        className="mb-4"
      />

      {videoUrl && (
        <>
          <video
            ref={videoRef}
            src={videoUrl}
            controls
            width="100%"
            className="mb-4"
          />

          <div className="mb-4">
            <label className="block mb-1">Start Time (in seconds):</label>
            <input
              type="number"
              value={start}
              onChange={(e) => setStart(e.target.value)}
              className="border p-2 w-full mb-2"
              placeholder="e.g., 10"
            />
            <label className="block mb-1">End Time (in seconds):</label>
            <input
              type="number"
              value={end}
              onChange={(e) => setEnd(e.target.value)}
              className="border p-2 w-full"
              placeholder="e.g., 30"
            />
          </div>

          <button
            onClick={generateClip}
            className="bg-green-600 text-white px-4 py-2 rounded"
          >
            Generate Clip
          </button>
        </>
      )}

      {clips.length > 0 && (
        <div className="mt-6">
          <h3 className="font-medium mb-2">Generated Clips:</h3>
          {clips.map((clip, idx) => (
            <div key={idx} className="mb-4">
              <p>Clip {idx + 1} ({clip.start}s to {clip.end}s)</p>
              <video src={clip.url} controls width="100%" className="mb-2" />
              <a href={clip.url} download={`clip_${clip.start}_${clip.end}.mp4`} className="text-blue-600 underline">
                Download Clip
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VideoToShorts;
